import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/admin-afiliate.phucbaokhang.vn/httpdocs/app/src/app/(authen)/login/LoginClient.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/vhosts/admin-afiliate.phucbaokhang.vn/httpdocs/app/src/styles/login.css");
